// extracted by mini-css-extract-plugin
module.exports = {"w25h1hd":"w25h1hd","igzwg0l":"igzwg0l"};